module.exports = __webpack_public_path__ + "img/86.5.COD.e4a3f660.png";